import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe, faInfoCircle } from '@fortawesome/pro-duotone-svg-icons'

import appConfig from '../../config'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import { getPortalOwnerName } from '../../utils/api/internshipRequestPortal'
import { ColorsPalette } from '../../config/colors'
import { Routes } from '../../routes'
import AnonymousLanguagesMenu from './AnonymousLanguagesMenu'

const FORM_STYLE = {
  minWidth: '80vw',
  maxWidth: '90vw',
  borderRadius: '15px'
}

export const REQUESTER_STYLE = {
  width: '620px',
  maxWidth: '90vw',
  borderRadius: '15px'
}

const PortalLayout = ({ children, displayInstitution = true, errorMessage = '', portalData, style = FORM_STYLE, title = 'internship_request_portal.title' }) => {
  const t = useSelector(selectTranslate)

  const institutionName = getPortalOwnerName(portalData)

  return (
    <div className='flex-column anonymous-form-wrapper'>
      <div className='flex-fill' />

      <div className='form-bg' />

      <div className='form-grid'>
        <div style={style} className='flex-column form-wrapper'>
          <div className='portal-header'>
            <div className='brand'>
              <img src='/assets/interneo_logo.svg' alt='interneo-logo' />
              <div className='version'>V{appConfig.version}</div>
            </div>

            {displayInstitution && institutionName.length !== 0 && (
              <div className='institution'>
                <div className='name'>{institutionName}</div>
                <div className='purpose'>{t(title)}</div>
              </div>
            )}

            <div className='language'>
              <AnonymousLanguagesMenu icon={faGlobe} />
            </div>
          </div>

          <div className='flex-fill' />

          {errorMessage.length !== 0 && (
            <>
              <div className='flex-fill' />

              <div className='modal-inner-container warning'>
                <div className='flex-row ai-bl'>
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    color={ColorsPalette.WARNING_FONT}
                  />
                  <span className='pdl-4'><strong>{t(errorMessage)}</strong></span>
                </div>
                <br />

                <p>
                  <span>{t('internship_request_portal.redirect.title')}</span>
                  <span className='pdl-4'>
                    {t('internship_request_portal.redirect.call_to_action')} <Link to={Routes.LOGIN}>{t('internship_request_portal.redirect.button')}</Link>.
                  </span>
                </p>
              </div>

              <div className='flex-fill' />
            </>
          )}

          {children}
        </div>
      </div>

      <div className='flex-fill' />
    </div>
  )
}

export default PortalLayout
